import { defineMessage } from 'services/localization';

export const messages = {
    uploadOcrButtonTitle: defineMessage('upload_via_approvalmax_capture'),
    uploadOcrButtonDescription: defineMessage('approvalmax_will_captur__no_manual_entry_needed'),
    uploadButtonTitle: defineMessage('upload_as_regular_attachment'),
    uploadButtonDescription: defineMessage('manually_fill_in_the_templatename_fields'),
    filesDragMessage: defineMessage('drag_drop_to_upload_as_files'),
    fileToOcrDragMessage: defineMessage('upload_via_approvalmax_capture'),
};
